var exports = {
  "n": "x31de4314--260f59--link",
};

module.exports = exports;
